import { Component, Input, ElementRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';

import { Resolutions } from '@core/domain/state/core.state';
import { ContentItemTree } from '@features/cms-render/domain/models/contentItemTree';

@Component({
    selector: 'slice-stacked',
    templateUrl: './slice-stacked.component.html',
    styleUrls: ['./slice-stacked.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SliceStackedComponent {
    @Input() public element: ContentItemTree;

    @Input() public direction: string;

    @Input() public resolution: Resolutions;

    @Input() public hasLogoSections: boolean = false;

    @ViewChild('container') public container: ElementRef;
}
